import { render, staticRenderFns } from "./situacao-academica.vue?vue&type=template&id=33597386"
import script from "./situacao-academica.vue?vue&type=script&lang=js"
export * from "./situacao-academica.vue?vue&type=script&lang=js"
import style0 from "./situacao-academica.vue?vue&type=style&index=0&id=33597386&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports